import { render, staticRenderFns } from "./DrawerGiftByCategory.vue?vue&type=template&id=38ad74a0&scoped=true&"
import script from "./DrawerGiftByCategory.vue?vue&type=script&lang=js&"
export * from "./DrawerGiftByCategory.vue?vue&type=script&lang=js&"
import style0 from "./DrawerGiftByCategory.vue?vue&type=style&index=0&id=38ad74a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad74a0",
  null
  
)

export default component.exports